import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../store/fileTypes";
import { selectFileTypesSearchText } from "../../../store/fileTypes/selectors/selectFileTypesSearchText";

export const FileTypesSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectFileTypesSearchText);

  return (
    <IonSearchbar
      value={searchText}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setSearchText(value));
      }}
      debounce={700}
      placeholder={"Buscar tipo de archivo..."}
    />
  );
};
